import { Turbo } from '@hotwired/turbo-rails'

// In the apps, a browser-history pop (history.back()) is a screen change only the
// native stack can make: left to Turbo, the previous page renders inside the current
// screen, whose bar keeps its buttons and gains the new page's. Routed to recede, the
// app pops the screen itself and restores the page beneath, as after a deletion.
const native = /Hotwire Native|Turbo Native/.test(navigator.userAgent)

let page = { path: location.pathname, href: location.href, state: history.state }
document.addEventListener('turbo:load', () => {
  page = { path: location.pathname, href: location.href, state: history.state }
})

if (native) {
  // Capture phase: on window, it runs before Turbo's own popstate listener.
  window.addEventListener('popstate', (event) => {
    // Same-page pops (an anchor, then back) stay Turbo's: a re-render, no screen change.
    if (!event.state?.turbo || location.pathname === page.path) return

    event.stopImmediatePropagation()
    // The browser has already moved to the popped entry while the screen keeps its page.
    // Put the page's URL back: with nothing to pop (a tab root), a reload or a
    // pull-to-refresh would otherwise load the popped page into this screen, and the
    // bridge controllers' page guards would mute this page's replays.
    history.replaceState(page.state, '', page.href)
    Turbo.visit('/recede_historical_location')
  }, true)
}
